import { useEffect } from 'react'
import moment from 'moment'

import { config } from '@/config'
import { syncHubspotVisibilityFromBodyClass } from '@/hooks/use-hubspot-chat-visibility'
import { useUser } from '@/hooks/use-user'
import { axiosInstance } from '@/providers/rest-data-provider/utils'

export function HubSpotChat() {
	const { user } = useUser()

	const configureHubspotConversations = async () => {
		let token = localStorage.getItem('X-Hubspot-Token')
		const tokenExpiry = localStorage.getItem('X-Hubspot-Token-Expiry')

		// If the token does not exist or has expired, request a new one from the server
		if (!token || (tokenExpiry && moment(tokenExpiry).isBefore(moment()))) {
			try {
				const response = await axiosInstance.get('/hubspot/token', {
					baseURL: config.fridge.integrationsApiUrl,
				})

				localStorage.setItem('X-Hubspot-Token', response?.data?.token)
				localStorage.setItem('X-Hubspot-Token-Expiry', response?.data?.tokenExpiry)
				token = response?.data?.token
			} catch (error) {
				// This will ensure that the HubSpot Chat is still loaded allowing user to communicate as an Unknown Visitor.
				console.error('Failed to get HubSpot visitor token:', error)
			}
		}

		window.hsConversationsSettings = {
			identificationEmail: user?.email,
			identificationToken: token || '',
		}

		window.HubSpotConversations.widget.load()
		syncHubspotVisibilityFromBodyClass()
	}

	useEffect(() => {
		if (!user || window._hubspot_initialized) return

		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.id = 'hs-script-loader'
		script.async = true
		script.defer = true
		script.src = '//js-na1.hs-scripts.com/5924808.js'
		document.body.appendChild(script)

		script.onload = () => {
			window._hubspot_initialized = true
			window.hsConversationsSettings = {
				loadImmediately: false,
			}
			if (!Array.isArray(window.hsConversationsOnReady)) {
				window.hsConversationsOnReady = []
			}
			window.hsConversationsOnReady.push(configureHubspotConversations)
		}

		// Cleanup only if the script was added dynamically
		return () => {
			if (!window._hubspot_initialized) {
				document.body.removeChild(script)
			}
		}
	}, [user])

	return null
}
